<!-- 用于弹出层刻度尺组件 -->
<template>
  <van-popup v-model="show" round position="bottom" @closed="bindClose">
    <div
      class="container"
      v-if="show"
      v-buried
      :data-buried="buried ? 'BG_RECORD_BODY_DATA_' + buried : ''"
    >
      <div class="title">{{ title }}</div>
      <div class="content">
        <div class="value">
          <span class="number">{{ curNum }}</span>
          <span class="unit">{{ unit }}</span>
        </div>
        <MyRuler
          style="margin-bottom: 48px"
          @change="bindRulerNum"
          :NowNum="defaultNum"
          :maxNum="maxNum"
          :oneGridValue="oneGridValue"
          :minNum="minNum"
        />
        <div class="btn-content">
          <div class="btn-item cancel" @click="bindClose">取消</div>
          <div
            class="btn-item confirm"
            @click="bindConfirm"
            v-clickBuried
            :data-click-buried="
              buried ? 'CLICK_RECORD_BODY_DATA_' + buried : ''
            "
            >确定</div
          >
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import MyRuler from './ruler.vue'
export default {
  components: {
    MyRuler
  },
  props: {
    //埋点key
    buried: {
      type: String,
      default: ''
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    // 每个格子多大
    oneGridValue: {
      type: Number,
      default: 1
    },
    title: {
      //标题
      type: String,
      default: ''
    },
    unit: {
      //单位
      type: String,
      default: ''
    },
    value: {
      //是否显示popup
      type: Boolean,
      default: false
    },
    defaultNum: {
      //刻度尺默认值
      type: Number,
      default: 50
    },
    maxNum: {
      //刻度最大值
      type: Number,
      default: 100
    },
    minNum: {
      //刻度最小值
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      curNum: 0
    }
  },
  watch: {
    value() {
      this.show = this.value
    }
  },
  computed: {},
  created() {
    this.show = this.value
  },
  mounted() {},
  methods: {
    bindRulerNum(value) {
      this.curNum = value
    },
    bindClose() {
      this.$emit('input', false)
    },
    bindConfirm() {
      this.$emit('confirm', this.curNum)
      this.bindClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup--round {
  border-radius: 8px 8px 0px 0px;
}

.container {
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;

  .title {
    text-align: center;
    height: 46px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    background: #f9f9f9;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 46px;
    margin-bottom: 42px;
  }

  .content {
    text-align: center;

    .value {
      margin-bottom: 20px;

      .number {
        font-size: 32px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #6236ff;
        line-height: 37px;
        letter-spacing: 1px;
        margin-right: 10px;
      }

      .unit {
        font-size: 14px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #6236ff;
        line-height: 16px;
      }
    }
  }
}

.btn-content {
  padding: 0px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 34px;

  .btn-item {
    text-align: center;
    width: 148px;
    height: 42px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f1f1f1;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 42px;
  }

  .confirm {
    background: #6236ff;
    border: 1px solid #6236ff;
    color: #ffffff;
  }
}
</style>
